import React from 'react';
import { makeStyles } from '@material-ui/core';
import RadioButtonsGroup from 'components/RadioButton';
import uniqueId from 'lodash/uniqueId';
import Checkbox from '../Checkbox';
import Signature from '../Signature/signature';
import TextArea from '../TextArea';
import TextInput from '../TextInput';
import DetailMediaUploader from '../MultiMediaUpload/DetailMediaUploader';
import { TASK_EVIDENCE_TYPE } from 'utils/constants/task';
import isEmpty from 'lodash/isEmpty';

const style = makeStyles(() => ({
  image: {
    height: '50px',
    width: '50px',
    borderRadius: '50%',
    backgroundSize: 'cover',
  },

  evidenceItem: {
    paddingBottom: '1rem',
    textAlign: 'left',

    '& span': {
      display: 'block',
    },
  },

  signaturePreview: {
    display: 'none',
  },
  radioButtonRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  formGroupClassName: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const DISPLAY_TYPE = {
  image: 'image',
  evidenceArray: 'evidence-array',
  string: 'string',
};

const renderText = (data, t) => {
  if (TASK_EVIDENCE_TYPE[data] && TASK_EVIDENCE_TYPE[data].name) {
    return t(TASK_EVIDENCE_TYPE[data].name);
  }
  return data;
};

export const getRowValue = ({
  data,
  setValue,
  evidenceValues,
  rawData,
  rowData,
  disabled = false,
  t,
}) => {
  const valueType = data && data.type;
  const classes = style();
  switch (valueType) {
    case TASK_EVIDENCE_TYPE.OPTION_SINGLE.id: {
      const vals =
        evidenceValues && evidenceValues.find(ev => ev.id === rawData.id);
      const selectedOptions =
        vals &&
        vals.contents.value.options
          .filter(f => f.selected)
          .map(m => ({ id: m.title, value: m.title }));
      return (
        <RadioButtonsGroup
          onChange={vals => setValue({ vals, rowData, id: rawData.id })}
          value={isEmpty(selectedOptions) ? { value: '' } : selectedOptions[0]}
          options={data.value.options.map(m => ({
            id: m.title,
            value: m.title,
            uniqueId: uniqueId('radio'),
          }))}
          item={{ valueType: 'object' }}
          classNames={classes.radioButtonRow}
          disabled={disabled}
        />
      );
    }
    case TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id: {
      const vals =
        evidenceValues && evidenceValues.find(ev => ev.id === rawData.id);
      const selectedOptions =
        vals &&
        vals.contents.value.options.filter(f => f.selected).map(m => m.title);
      return (
        <Checkbox
          options={data.value.options.map(m => ({
            id: m.title,
            name: m.title,
            uniqueId: uniqueId('radio'),
          }))}
          value={selectedOptions}
          onChange={vals => setValue({ vals, rowData, id: rawData.id })}
          formGroupClassName={classes.formGroupClassName}
          className={classes.formGroupClassName}
          disabled={disabled}
        />
      );
    }

    case TASK_EVIDENCE_TYPE.SIGNATURE.id: {
      const vals =
        evidenceValues && evidenceValues.find(ev => ev.id === rawData.id);
      const base64url = vals && vals.contents.value;
      return (
        <Signature
          onChange={vals => setValue({ vals, rowData, id: rawData.id })}
          base64url={base64url}
          // classesNames={classes.signaturePreview} // this will hide the preview
          disabled={disabled}
        />
      );
    }
    case TASK_EVIDENCE_TYPE.DESCRIPTION.id: {
      const vals =
        evidenceValues && evidenceValues.find(ev => ev.id === rawData.id);
      const text = vals && vals.contents.value;
      return (
        <TextArea
          maxLength={250}
          onChange={vals => setValue({ vals, rowData, id: rawData.id })}
          value={text || ''}
          placeholder={'Enter description'}
          disabled={disabled}
        />
      );
    }
    case TASK_EVIDENCE_TYPE.NUMERIC.id: {
      const vals =
        evidenceValues && evidenceValues.find(ev => ev.id === rawData.id);
      const num = vals && vals.contents.value;

      return (
        <TextInput
          type={'number'}
          onChange={vals => setValue({ vals, rowData, id: rawData.id })}
          value={num || ''} // empty string will clear the input when delete is pressed
          placeholder={'Enter number'}
          maxLength={50}
          disabled={disabled}
        />
      );
    }
    case TASK_EVIDENCE_TYPE.IMAGE.id: {
      const vals =
        evidenceValues && evidenceValues.find(ev => ev.id === rawData.id);
      const image = vals && vals.contents.value;
      return (
        <DetailMediaUploader
          onChange={vals => setValue({ vals, rowData, id: rawData.id })}
          mediaType={['IMAGE']}
          noOfMediaFilesAllowed={1}
          displaySelectedMedia={image}
          disabled={disabled}
          value={image}
        />
      );
    }
    case TASK_EVIDENCE_TYPE.AUDIO.id: {
      const vals =
        evidenceValues && evidenceValues.find(ev => ev.id === rawData.id);
      const audio = vals && vals.contents.value;

      return (
        <DetailMediaUploader
          onChange={vals => setValue({ vals, rowData, id: rawData.id })}
          mediaType={['AUDIO']}
          noOfMediaFilesAllowed={1}
          displaySelectedMedia={audio}
          disabled={disabled}
        />
      );
    }

    case TASK_EVIDENCE_TYPE.CHECKBOX.id: {
      // this is just a single checkbox
      const vals =
        evidenceValues && evidenceValues.find(ev => ev.id === rawData.id);
      let selectedOptions = [];
      if (vals && vals.contents.value) {
        selectedOptions = ['CB'];
      } else {
        selectedOptions = [];
      }
      return (
        <Checkbox
          options={[{ id: 'CB', name: '' }]}
          value={selectedOptions}
          onChange={vals => setValue({ vals, rowData, id: rawData.id })}
          formGroupClassName={classes.formGroupClassName}
          className={classes.formGroupClassName}
          disabled={disabled}
        />
      );
    }
    default:
      return renderText(data, t);
  }
};
